import { Card, type CardProps } from "@clipboard-health/ui-components";
import { mergeSxProps } from "@clipboard-health/ui-components";

import { DOUBLE_BORDER_COLOR } from "../Double/constants";

interface ShiftCardWrapperProps extends CardProps {
  isUrgent?: boolean;
  isBundle?: boolean;
  isDouble?: boolean;
  isTopPicked?: boolean;
}

export function ShiftCardWrapper(props: ShiftCardWrapperProps) {
  const {
    isUrgent = false,
    isBundle = false,
    isDouble = false,
    isTopPicked = false,
    variant = "quaternary",
    outlined = true,
    sx,
    ...restProps
  } = props;

  return (
    <Card
      variant={variant}
      outlined={isUrgent || isBundle || isDouble || isTopPicked || outlined}
      sx={mergeSxProps(
        (theme) => ({
          minHeight: theme.size?.shiftCard.minHeight,
          borderColor: (theme) => {
            if (isUrgent) {
              return theme.palette.shift?.urgent.border;
            }
            if (isBundle) {
              return theme.palette.shift?.bundle?.border;
            }
            if (isDouble) {
              return DOUBLE_BORDER_COLOR;
            }
            return undefined;
          },
          ...(isTopPicked && {
            background: (theme) => theme.palette?.shift?.forYou.background,
            border: (theme) => theme.palette.shift?.forYou.border,
          }),
        }),
        sx
      )}
      {...restProps}
    />
  );
}
